// Zurueckstellen-Menue der Inbox (aus routes/Inbox.tsx herausgezogen, damit
// die P5-Kontextliste es mitbenutzt). Verhalten unveraendert.

import { useEffect, useRef } from "preact/hooks";
import { snoozePresets } from "../../lib/inboxTime";

export interface SnoozePickerProps {
  onPick: (until: string) => void;
  onClose: () => void;
}

export function SnoozePicker({ onPick, onClose }: SnoozePickerProps): preact.JSX.Element {
  const presets = snoozePresets();
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onDoc = (e: MouseEvent): void => {
      // Ignore clicks inside the wrapper INCLUDING the trigger button — the
      // trigger sits outside `ref`, so closing on its mousedown made the
      // subsequent click re-open the picker (toggle could never close it).
      const container = ref.current?.parentElement ?? ref.current;
      if (container && !container.contains(e.target as Node)) onClose();
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [onClose]);

  return (
    <div
      ref={ref}
      role="menu"
      class="absolute right-0 top-full mt-1 z-50 min-w-[180px] rounded border border-[color:var(--color-outline-variant)] bg-[color:var(--color-surface-container-lowest)] shadow-level-3"
    >
      {presets.map((p) => (
        <button
          key={p.until}
          type="button"
          role="menuitem"
          onClick={() => onPick(p.until)}
          class="w-full text-left px-3 py-2 text-xs hover:bg-[color:var(--color-surface-container-low)] focus:outline-none focus:bg-[color:var(--color-surface-container-low)] transition-colors"
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}

